import { render, staticRenderFns } from "./DashboardAreaSetting.vue?vue&type=template&id=122578c1&"
import script from "./DashboardAreaSetting.vue?vue&type=script&lang=js&"
export * from "./DashboardAreaSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports